import { orgSelectors } from 'ducks/orgs'
import { SellerIntegrationType } from 'opensolar-common'
import type { ComponentTypesV2 } from '../../types/selectComponent'
import { getSupplierConfigNonReact } from './hooks/useGetSupplierConfig'

const CITY_PLUMBING_DISTRIBUTOR_KEY = 'city_plumbing'
const OUTLET_DISTRIBUTOR_KEY = 'outlet'

export const getCountryDefaultSupplier = (countryIso: string): SellerIntegrationType | undefined => {
  if (['AU'].includes(countryIso)) return getSupplierConfigNonReact(OUTLET_DISTRIBUTOR_KEY) || undefined
  if (['GB', 'UK', 'JE', 'GG'].includes(countryIso)) {
    return getSupplierConfigNonReact(CITY_PLUMBING_DISTRIBUTOR_KEY) || undefined
  }
  return undefined
}

export const getCountrySuppliers = (countryIso: string): SellerIntegrationType[] | undefined => {
  if (['AU'].includes(countryIso)) {
    const state = (window as any).reduxStore?.getState?.()
    if (state) {
      const allEnabled = orgSelectors.getEnabledSellerIntegrationsConfig(state)
      if (allEnabled?.length > 0) return allEnabled
    }
    const outletDistributorConfig = getSupplierConfigNonReact(OUTLET_DISTRIBUTOR_KEY)
    if (outletDistributorConfig) return [outletDistributorConfig]
    return undefined
  }
  if (['GB', 'UK', 'JE', 'GG'].includes(countryIso)) {
    const cityPlumbingDistributorConfig = getSupplierConfigNonReact(CITY_PLUMBING_DISTRIBUTOR_KEY)
    const configs = [cityPlumbingDistributorConfig].filter((config) => config !== null) as SellerIntegrationType[]
    if (configs.length > 0) return configs
  }
  return undefined
}

export const otherCategories = [
  'general',
  'dc_optimizer',
  'isolator',
  'meter',
  'cable',
  'battery_accessory',
  'battery_inverter',
  'inverter_accessory',
  'mounting_rail',
  'mounting_roof_anchor',
  'mounting_clamp',
  'mounting_flashing',
  'mounting_roof_fixing',
  'mounting_other',
  'ev_charger',
  'subscription',
  'heat_pump',
] as ComponentTypesV2[]

export const majorComponentCategories = ['module', 'inverter', 'battery', 'other', 'others']
